import { ApiRequest } from '@zeal/zeal-lib';
import { ENDPOINTS } from '../endpoints';
import { BrandingConfig } from './types';
import {
	DEFAULT_MOCK_DOMAIN,
	enableDevToolsForBranding,
	MOCK_DOMAIN_KEY,
} from './utils';

export async function brandingConfig() {
	const req = new ApiRequest(ENDPOINTS.acquirer.brandingConfig).addHeader(
		'Accept',
		'application/json'
	);

	if (enableDevToolsForBranding()) {
		/**
		 * This `x-dev-branding-origin` header is used to mock the origin of the request to the branding config endpoint.
		 * This is used for testing the branding config in the dev environment.
		 * If the mock domain is not set, it will be set to the default mock domain.
		 */
		let mockDomain = localStorage.getItem(MOCK_DOMAIN_KEY) || '';
		if (!mockDomain) {
			localStorage.setItem(MOCK_DOMAIN_KEY, DEFAULT_MOCK_DOMAIN);
			mockDomain = DEFAULT_MOCK_DOMAIN;
		}
		req.addHeader('x-dev-branding-origin', mockDomain);
	}

	return req.GET<BrandingConfig>({
		noAuth: true,
	});
}
